interface ChromeRuntime {
  sendMessage: (
    extensionId: string,
    message: unknown,
    callback?: (response: unknown) => void
  ) => void;
  lastError?: {
    message: string;
  };
}

interface Chrome {
  runtime?: ChromeRuntime;
}

interface ExtensionReply {
  success: boolean;
  data?: unknown;
  error?: string;
}

declare global {
  interface Window {
    chrome?: Chrome;
  }
}

/**
 * Send message to browser extension
 *
 * @param extensionId - ID of the extension
 * @param message - content of the message
 */
export const sendMessageToExtension = (extensionId: string, message: unknown): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    // Get 'chrome' browser object from global and check if it supports messaging
    const chromeRuntime = window.chrome?.runtime;
    if (!chromeRuntime || typeof chromeRuntime.sendMessage !== 'function') {
      throw new Error('Extension messages are not supported');
    }

    try {
      chromeRuntime.sendMessage(extensionId, message, (reply: unknown) => {
        if (chromeRuntime.lastError) {
          reject(chromeRuntime.lastError.message);
          return;
        }

        const extensionReply = reply as ExtensionReply;
        if (extensionReply?.success) {
          resolve(extensionReply.data);
          return;
        }

        reject(extensionReply?.error);
      });
    } catch (error) {
      reject(error);
    }
  });
};
